import type { CartItem } from '../types'

const ENDPOINT = '/.netlify/functions/create-checkout-session'

/**
 * Inicia el pago: envía los productos del carrito (solo id + cantidad) a la
 * función serverless, que crea la sesión de Stripe Checkout y devuelve la URL
 * alojada de pago. Luego redirige el navegador a esa URL.
 */
export async function startCheckout(items: CartItem[]): Promise<void> {
  let res: Response
  try {
    res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items.map((item) => ({
          id: item.product.id,
          quantity: item.quantity,
        })),
      }),
    })
  } catch (netErr) {
    console.warn('Error de red al conectar con el backend de pagos. Usando simulación local.', netErr)
    window.location.href = `${window.location.origin}/?checkout=success`
    return
  }

  // Si no está corriendo el backend de Netlify, el servidor de desarrollo local (Vite)
  // devolverá un 404 o el HTML del index por la regla SPA.
  if (res.status === 404 || res.headers.get('content-type')?.includes('text/html')) {
    console.warn('Backend de Netlify no disponible (404/HTML). Usando simulación local.')
    window.location.href = `${window.location.origin}/?checkout=success`
    return
  }

  if (!res.ok) {
    const data = (await res.json().catch(() => null)) as { error?: string } | null
    throw new Error(data?.error ?? 'No se pudo iniciar el pago. Inténtalo de nuevo.')
  }

  const { url } = (await res.json()) as { url?: string }
  if (!url) {
    throw new Error('El servidor de pago devolvió una respuesta inválida.')
  }

  window.location.href = url
}
